export enum PositionUnit {
  Oz,
  Million,
}

export namespace PositionUnit {
  let elements = [PositionUnit.Oz, PositionUnit.Million];
  let alias = "com.bcdfx.model.PositionUnit";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
